import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/channels`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/channels/${id}`);
  },
  async findAll() {
    return axios.get('/channels');
  },
  async delete({ id }) {
    return axios.delete(`/channels/${id}`);
  },
  async update(formData) {
    return axios.put(`/channels/${formData.id}`, formData);
  }
};
